export default __webpack_public_path__ + "static/media/bg.787e45a7.webp";